import { ModelLocalStorageDB } from "@/models/ModelLocalStorageDB";
import { addMagicMethods } from "@/helpers/addMagicMethods";
export class TestModel extends ModelLocalStorageDB {
    constructor(id = null) {
        super('test_table', +id);
        return addMagicMethods(this);
    }
    __get(target, prop, receiver) {
        switch (prop) {
            case 'virtual_field':
                return [receiver.field_1, "super_ninja"].filter(v => !!v).join(' ');
        }
        return super.__get(target, prop, receiver);
    }
    __set(target, prop, value, receiver) {
        switch (prop) {
            case 'virtual_field':
                return alert('test set data into virtual_field');
        }
        return super.__set(target, prop, value, receiver);
    }
}
